import protoRoot from "../proto-root";

const name = "startVideoReceivingResponse";

function create({ result, previewAspectRatio }) {
  const StartVideoReceiving = protoRoot.lookupType(
    "comm.StartVideoReceivingRPCResponse"
  );
  const Result = StartVideoReceiving.lookupEnum("Result");

  const response = StartVideoReceiving.create({
    result: Result.values[result],
    previewAspectRatio
  });
  return { payload: response, name };
}

export default {
  create,
  name
};

// message StartVideoReceivingRPCResponse {
//     enum Result {
//         SUCCESS = 0;
//         ALREADY_RUNNING = 1;
//     }
//     Result result = 1;
//     float previewAspectRatio = 2;
// }
